/* src/@fuse/components/navigation/navigation.component.scss */
fuse-navigation {
  display: flex;
  flex: 1 0 auto;
}
fuse-navigation > .nav {
  margin: 0;
  padding: 0;
  width: 100%;
}
.close-all {
  padding: 2px 5px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.2);
  display: inline-block;
  font-size: 0.6em;
  cursor: pointer;
}
/*# sourceMappingURL=data:application/json;base64,ewogICJ2ZXJzaW9uIjogMywKICAic291cmNlcyI6IFsic3JjL0BmdXNlL2NvbXBvbmVudHMvbmF2aWdhdGlvbi9uYXZpZ2F0aW9uLmNvbXBvbmVudC5zY3NzIl0sCiAgInNvdXJjZXNDb250ZW50IjogWyJAdXNlICdAZnVzZS9zY3NzL3BhcnRpYWxzL2JyZWFrcG9pbnRzLnNjc3MnIGFzIGJyZWFrcG9pbnRzO1xuXG5mdXNlLW5hdmlnYXRpb24ge1xuICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgZmxleDogMSAwIGF1dG87XG5cbiAgICA+IC5uYXYge1xuICAgICAgICBtYXJnaW46IDA7XG4gICAgICAgIHBhZGRpbmc6IDA7XG4gICAgICAgIHdpZHRoOiAxMDAlO1xuICAgIH1cbn1cblxuLmNsb3NlLWFsbHtcbiAgICBwYWRkaW5nOiAycHggNXB4O1xuICAgIGJvcmRlci1yYWRpdXM6IDRweDtcbiAgICBiYWNrZ3JvdW5kOiByZ2JhKDI1NSwgMjU1LCAyNTUsIDAuMik7XG4gICAgZGlzcGxheTogaW5saW5lLWJsb2NrO1xuICAgIGZvbnQtc2l6ZTogMC42ZW07XG4gICAgY3Vyc29yOiBwb2ludGVyO1xufSJdLAogICJtYXBwaW5ncyI6ICI7QUFFQTtBQUNJLFdBQUE7QUFDQSxRQUFBLEVBQUEsRUFBQTs7QUFFQSxnQkFBQSxFQUFBLENBQUE7QUFDSSxVQUFBO0FBQ0EsV0FBQTtBQUNBLFNBQUE7O0FBSVIsQ0FBQTtBQUNJLFdBQUEsSUFBQTtBQUNBLGlCQUFBO0FBQ0EsY0FBQSxLQUFBLEdBQUEsRUFBQSxHQUFBLEVBQUEsR0FBQSxFQUFBO0FBQ0EsV0FBQTtBQUNBLGFBQUE7QUFDQSxVQUFBOzsiLAogICJuYW1lcyI6IFtdCn0K */
